import { useState } from "react";
import { LogIn, Eye, EyeOff } from "lucide-react";

const AuthHandler = ({ onLogin, loading }) => {
  const [credentials, setCredentials] = useState({ username: "", password: "" });
  const [showPassword, setShowPassword] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    onLogin(credentials);
  };

  return (
    <div className="min-h-screen pt-32 pb-16 bg-[#F5F5F5]">
      <div className="max-w-md mx-auto px-4">
        <div className="bg-white p-8 border border-[#E5E5E5]">
          <h1
            className="text-2xl font-black text-[#0A0A0A] mb-6 text-center"
            style={{ fontFamily: "'Chivo', sans-serif" }}
          >
            ADMIN<span className="text-[#FF6B00]">LOGIN</span>
          </h1>
          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label className="block text-xs font-bold uppercase tracking-wide text-[#525252] mb-2">
                Username
              </label>
              <input
                type="text"
                value={credentials.username}
                onChange={(e) =>
                  setCredentials({ ...credentials, username: e.target.value })
                }
                className="w-full px-4 py-3 border border-[#E5E5E5] focus:border-[#FF6B00] focus:outline-none"
                required
                data-testid="admin-username"
              />
            </div>
            <div>
              <label className="block text-xs font-bold uppercase tracking-wide text-[#525252] mb-2">
                Password
              </label>
              <div className="relative">
                <input
                  type={showPassword ? "text" : "password"}
                  value={credentials.password}
                  onChange={(e) =>
                    setCredentials({ ...credentials, password: e.target.value })
                  }
                  className="w-full px-4 py-3 border border-[#E5E5E5] focus:border-[#FF6B00] focus:outline-none pr-12"
                  required
                  data-testid="admin-password"
                />
                <button
                  type="button"
                  onClick={() => setShowPassword(!showPassword)}
                  className="absolute right-4 top-1/2 -translate-y-1/2 text-[#525252] hover:text-[#FF6B00]"
                >
                  {showPassword ? (
                    <EyeOff className="w-5 h-5" />
                  ) : (
                    <Eye className="w-5 h-5" />
                  )}
                </button>
              </div>
            </div>
            <button
              type="submit"
              disabled={loading}
              className="w-full bg-[#FF6B00] text-white font-bold uppercase tracking-wide py-4 hover:bg-[#E65000] transition-all flex items-center justify-center gap-2 disabled:opacity-50"
              data-testid="admin-login-btn"
            >
              {loading ? (
                "Logging in..."
              ) : (
                <>
                  <LogIn className="w-5 h-5" />
                  Login
                </>
              )}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AuthHandler;
